module.exports = __webpack_public_path__ + "img/story11-eisenstadt-4.jpg";